export const getStatusStyle = (status: string): string => {
  switch (status) {
    case 'prospect': return 'bg-purple-100 text-purple-700 dark:bg-purple-950/30 dark:text-purple-300';
    case 'actif': return 'bg-emerald-100 text-emerald-700 dark:bg-emerald-950/30 dark:text-emerald-300';
    case 'inactif': return 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300';
    case 'bloque': return 'bg-red-100 text-red-700 dark:bg-red-950/30 dark:text-red-300';
    case 'ferme': return 'bg-zinc-100 text-zinc-700 dark:bg-zinc-900/40 dark:text-zinc-300';
    default: return 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300';
  }
};

export const getStatusLabel = (status: string): string => {
  switch (status) {
    case 'prospect': return 'Prospect';
    case 'actif': return 'Actif';
    case 'inactif': return 'Inactif';
    case 'bloque': return 'Bloqué';
    case 'ferme': return 'Fermé';
    default: return status;
  }
};

export const getErrorMessage = (error: any, defaultMsg: string = 'Une erreur est survenue'): string => {
  const detail = error?.response?.data?.detail;
  
  if (typeof detail === 'string') {
    return detail;
  }
  
  if (Array.isArray(detail)) {
    // Pydantic validation errors are arrays of objects
    return detail.map((err: any) => err.msg || JSON.stringify(err)).join(', ');
  }
  
  if (typeof detail === 'object' && detail !== null) {
    // Single error object
    return detail.msg || JSON.stringify(detail);
  }
  
  return defaultMsg;
};
